module.exports = __webpack_public_path__ + "img/scroll-arrow.90479e02.svg";